export const ON_CHANGE_DELAY = 1000;
export const WHITE_LABELS = {
  CAR: 'Car',
  MOTORCYCLE: 'Motorcycle',
  COMMERCIAL: 'Commercial',
} as const;
